import type { Token } from 'commons/modules/auth/token';

import { KEYCLOAK_ROLES, ROLE_MAPPING, SYSTEM_ROLES } from 'constants/globals';

export const getRole = (authorities: string[]) => {
  if (!authorities || authorities.length === 0) {
    return SYSTEM_ROLES.otro;
  }

  for (const authority of authorities) {
    const role = ROLE_MAPPING.get(authority);
    if (role) {
      return role;
    }
  }
  return SYSTEM_ROLES.otro;
};

export const isSuperAdministrator = (token: Token) => {
  return token?.realm_access?.roles?.includes(KEYCLOAK_ROLES.superAdmin);
};
